import Monitoring from "../components/views/location-tracking/monitoring.vue";
import vehicleTracking from "../components/views/location-tracking/vehicleTracking.vue";
import traccarMonitoring from "../components/views/location-tracking/traccarMonitoring.vue";
import traccarMonitoringBeta from "../components/views/location-tracking/traccarMonitoringBeta.vue";
const routes = [
  {
    path: "/monitoring",
    component: Monitoring,
    name: "monitoring",
    meta: {
      description: "",
      title: "Surveyor Tracking",
      requiresAuth: true,
    },
  },
  {
    path: "/vehicle-tracking",
    component: vehicleTracking,
    name: "vehicleTracking",
    meta: {
      description: "",
      title: "Vehicle Tracking",
      requiresAuth: true,
    },
  },
  // {
  //   path: "/route-tracking",
  //   component: traccarMonitoring,
  //   name: "Route Tracking",
  //   meta: {
  //     description: "",
  //     title: "Route Tracking",
  //     requiresAuth: true,
  //   },
  // },
  {
    path: "/route-tracking",
    component: traccarMonitoringBeta,
    name: "Route Tracking",
    meta: {
      description: "",
      title: "Route Tracking",
      requiresAuth: true,
    },
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes/monitoring.route.js